<div class="wrapper-modal wrapper-modal-change-price">
  <div class="wrapper-content-modal">
    <div class="title-day">
      <span class="day">{{setCustomSelectedDayName}} </span>
      <span class="date">{{setCustomSelectedDateKey | date: 'dd.MM.yyyy'}}</span>
    </div>
    <div class="wrapper-terms-change-price-modal">
      <h1>Termini</h1>
      <div class="item-terms">
        <div class="item-term" *ngFor="let term of setCustomSelectedDayData" (click)="onTermSelected(term)">
          <div>
            <span>Početak termina:</span>
            <span class="value">{{term.start_time}}</span>
          </div>
          <div>
            <span>Kraj termina:</span>
            <span class="value">{{term.end_time}}</span>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="termSelected" class="wrapper-terms-change-price-modal">
      <h1>Slotovi</h1>
      <div *ngFor="let slot of termSelected.slots" class="wrapper-slot-change">
        <div>
          <span>Opis:</span>
          <span class="label">{{slot.description}}</span>
        </div>

        <div class="wrapper-input" style="margin-top: 16px;">
          <span class="label-input">Cena:</span>
          <div class="zc-input">
            <input class="zc-input"
                   type="number"
                   #inputCena
                   [value]="slot.override?.price ?? slot.price"
            >
          </div>
        </div>
        <button class="zc-btn zc-btn--primary" (click)="prepareAndSave(termSelected, slot, inputCena.value, inputCena)">
          <p>Sačuvaj</p>
        </button>
      </div>
    </div>
    <div class="wrapper-btn-open-day">
      <button class="zc-btn zc-btn--gray" type="button" (click)="closeModal.emit()"><span>OTKAŽI</span></button>
    </div>
  </div>
</div>
